import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=cdc90e70&scoped=true&lang=pug&"
import script from "./Error.vue?vue&type=script&lang=js&"
export * from "./Error.vue?vue&type=script&lang=js&"
import style0 from "./Error.vue?vue&type=style&index=0&id=cdc90e70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../home/httpd/vhosts/tocin.com.tw/httpdocs/tocin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc90e70",
  null
  
)

export default component.exports